import { Skeleton } from '@speeki/global-ui-components';

import {
    DateCell,
    ListItem,
    MessageCell,
    ReportCell,
    StatusCell,
} from './SkeletonCaseListItem.styled';

interface SkeletonCaseListItemProps {
    numberOfElements?: number;
}

export const SkeletonCaseListItem = ({
    numberOfElements = 10,
}: SkeletonCaseListItemProps) => {
    return (
        <>
            {[...Array(numberOfElements).keys()].map((_, index) => (
                <ListItem key={index}>
                    <ReportCell>
                        <Skeleton height={20} width={`100%`} />
                    </ReportCell>
                    <StatusCell>
                        <Skeleton height={20} width={`100%`} />
                    </StatusCell>
                    <MessageCell>
                        <Skeleton height={20} width={`100%`} />
                    </MessageCell>
                    <DateCell>
                        <Skeleton height={20} width={`100%`} />
                    </DateCell>
                </ListItem>
            ))}
        </>
    );
};
